module.exports = __webpack_public_path__ + "media/images/overview-a16e24a02b75b7bbb04d16d73ee8435c.png";